import { BodyText, Button, HeadingOneText, TextInput } from '@mint/ui';
import { Link, RouteComponentProps } from 'react-router-dom';
import React, { useState } from 'react';
import { CardsetterMark } from '@cardsetter/brand';
import { changePasswordRequest } from '../../../actions';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';

const Main = styled.main`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;

  h1 {
    margin-bottom: 2rem;
  }

  a {
    display: block;
    text-align: center;
    font-size: 12px;
    text-decoration: none;
    color: rgba(0, 0, 0, 0.5);
  }
`;

const Form = styled.div`
  flex: 1;
  padding: 1rem 1rem 4rem;
  max-width: 400px;
  text-align: center;
`;

const ButtonWrapper = styled.div`
  text-align: center;
  margin-top: 1rem;
  margin-bottom: 3rem;
`;

const MarkWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 3rem;

  svg {
    font-size: 4rem;
    flex: 1;
  }
`;

export const AdminChangePasswordPage: React.FunctionComponent<
  RouteComponentProps<{ token: string }>
> = ({ match }): React.ReactElement => {
  const [password, setPassword] = useState('');
  const dispatch = useDispatch();

  const token = match.params.token;

  console.log(token);

  return (
    <Main>
      <Form>
        <MarkWrapper>
          <CardsetterMark />
        </MarkWrapper>
        <HeadingOneText>Change Password</HeadingOneText>
        <TextInput
          label="New Password"
          type="password"
          value={password}
          onChange={v => setPassword(v.target.value)}
        />
        <ButtonWrapper>
          <Button
            onClick={(): void => {
              dispatch(changePasswordRequest({ token, newPassword: password }));
            }}
          >
            Change Password
          </Button>
        </ButtonWrapper>
        <BodyText>
          <Link to="/admin/login">Back to Login</Link>
        </BodyText>
      </Form>
    </Main>
  );
};
